import React from 'react';

import IconButton from 'ds/IconButton';
import Layout from 'ds/Layout';
import ProductImg from 'ds/ProductImg';
import { EditableImage } from 'shared';

interface Props {
  onDeleteClick?: VoidFunction;
  image: EditableImage;
  disabled?: boolean;
  dimension?: number;
}

const ImageUploadThumbnail: React.FC<Props> = ({ onDeleteClick, image, disabled, dimension = 104 }) => {
  const imageUrl = image.url || (image.file ? URL.createObjectURL(image.file) : undefined);

  return (
    <Layout position="relative" height={dimension} width={dimension}>
      {image.key ? (
        <ProductImg
          srcKey={image.key}
          alt="product set image"
          size="thumbnail"
          style={{
            objectFit: 'cover',
            borderRadius: 8,
            width: dimension,
            height: dimension
          }}
        />
      ) : (
        <img
          src={imageUrl}
          alt="product set"
          style={{
            objectFit: 'cover',
            borderRadius: 8,
            width: dimension,
            height: dimension
          }}
        />
      )}
      {!!onDeleteClick && (
        <Layout position="absolute" right={10} top={10}>
          <IconButton
            size="xs"
            type="gray"
            name="close"
            stroke={2}
            disabled={disabled}
            onClick={e => {
              e.stopPropagation();
              onDeleteClick();
            }}
          />
        </Layout>
      )}
    </Layout>
  );
};

export default ImageUploadThumbnail;
